'use client';

import React from 'react';
import { usePathname } from '@/i18n/routing';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import FloatContact from '@/components/ui/FloatContact';

interface AppLayoutProps {
    children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
    const pathname = usePathname();
    const isBlankPage = pathname?.startsWith('/ai-demo');

    if (isBlankPage) {
        return <>{children}</>;
    }

    return (
        <>
            <Navbar />
            {children}
            <FloatContact />
            <Footer />
        </>
    );
}
